import { formatWorkflowPath } from "context/workflowReference";

// A stored target in one of two shapes, told apart by `target`: `{target, workflow, input_data}`, or the
// production `{blob_id, revision, session, workflow_alias, input_data, description}` that stage 3 migrates.
// docs/specs/2026-09-25-workflow-reference.md
export function readInvocationTarget(stored) {
  const value = stored || {};
  if ( value.target ) {
    return {
      org: value.target.org || null,
      blob: value.target.blob || null,
      revision: value.target.revision || null,
      session: value.target.session || null,
      workflow: value.workflow || null,
      inputData: value.input_data ?? null,
      description: null
    };
  }
  return {
    org: null,
    blob: value.blob_id || null,
    revision: value.revision || null,
    session: value.session || null,
    workflow: value.workflow_alias ? { definition: value.workflow_alias } : null,
    inputData: value.input_data ?? null,
    description: value.description || null
  };
}

export function scheduleDescription(schedule) {
  if ( !schedule ) {
    return null;
  }
  return schedule.description || readInvocationTarget(schedule.invocation_target).description;
}

export function formatInvocationTarget(schedule) {
  if ( !schedule || !schedule.invocation_target ) {
    return "No target";
  }
  const target = readInvocationTarget(schedule.invocation_target);
  if ( !target.blob ) {
    return JSON.stringify(schedule.invocation_target);
  }
  return [target.org, target.blob, target.revision, target.session].filter(Boolean).join(" / ");
}

export function formatTargetWorkflow(target) {
  return formatWorkflowPath(readInvocationTarget(target).workflow);
}
